module.exports = __webpack_public_path__ + "static/media/img-staff-small.1f7e82bd.png";